module.exports = __webpack_public_path__ + "img/__icon_HAKOWIEC.0604be47.svg";